import React from "react";
import { Typography, Row, Col, Image, Divider, Card, List } from "antd";

const { Title, Paragraph, Text } = Typography;

interface MalattiaRaraProps {
  titolo: string;
  descrizione: string[];
  immagineDescrizione: string;
  altImmagineDescrizione: string;
  sintomi: string[];
  diagnosi: string[];
  trattamento: string[];
  immagineTrattamento: string;
  altImmagineTrattamento: string;
  epidemiologia: {
    prevalenza: string;
    incidenza: string;
    etaMedia: string;
    rapportoSessi: string;
  };
  riferimenti: {
    nome: string;
    link: string;
  }[];
}

/**
 * Template per la pagina di una malattia rara
 * Utilizza questo componente passando le props necessarie per creare una pagina per ogni malattia
 */
const MalattiaRaraTemplate: React.FC<MalattiaRaraProps> = ({
  titolo,
  descrizione,
  immagineDescrizione,
  altImmagineDescrizione,
  sintomi,
  diagnosi,
  trattamento,
  immagineTrattamento,
  altImmagineTrattamento,
  epidemiologia,
  riferimenti,
}) => (
  <div style={{ padding: "20px" }}>
    <Title level={1}>{titolo}</Title>

    {/* Sezione Descrizione */}
    <Row gutter={[16, 24]}>
      <Col xs={24} md={12}>
        {descrizione.map((paragrafo, index) => (
          <Paragraph key={index} style={{ textAlign: "justify" }}>
            {paragrafo}
          </Paragraph>
        ))}
      </Col>

      <Col xs={24} md={12}>
        <Image
          src={immagineDescrizione}
          alt={altImmagineDescrizione}
          preview={false}
          style={{ width: "100%", height: "auto" }}
        />
      </Col>
    </Row>

    <Divider />

    {/* Sezione Sintomi */}
    <Title level={2} style={{ marginTop: "24px" }}>
      Sintomi e Segni Clinici
    </Title>

    <Row gutter={[16, 24]} style={{ marginTop: "16px" }}>
      <Col xs={24}>
        <List
          bordered
          dataSource={sintomi}
          renderItem={(item) => (
            <List.Item>
              <Text>{item}</Text>
            </List.Item>
          )}
        />
      </Col>
    </Row>

    {/* Sezione Epidemiologia */}
    <Title level={2} style={{ marginTop: "36px" }}>
      Epidemiologia
    </Title>

    <Row gutter={[16, 24]} style={{ marginTop: "16px" }}>
      <Col xs={24} md={24}>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={6}>
            <Card style={{ height: "100%" }} title="Prevalenza">
              <Paragraph style={{ textAlign: "center" }}>
                <Text strong style={{ fontSize: "16px" }}>
                  {epidemiologia.prevalenza}
                </Text>
              </Paragraph>
            </Card>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Card style={{ height: "100%" }} title="Incidenza">
              <Paragraph style={{ textAlign: "center" }}>
                <Text strong style={{ fontSize: "16px" }}>
                  {epidemiologia.incidenza}
                </Text>
              </Paragraph>
            </Card>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Card style={{ height: "100%" }} title="Età media di diagnosi">
              <Paragraph style={{ textAlign: "center" }}>
                <Text strong style={{ fontSize: "16px" }}>
                  {epidemiologia.etaMedia}
                </Text>
              </Paragraph>
            </Card>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Card style={{ height: "100%" }} title="Rapporto M:F">
              <Paragraph style={{ textAlign: "center" }}>
                <Text strong style={{ fontSize: "16px" }}>
                  {epidemiologia.rapportoSessi}
                </Text>
              </Paragraph>
            </Card>
          </Col>
        </Row>
      </Col>
    </Row>

    {/* Sezione Diagnosi */}
    <Title level={2} style={{ marginTop: "36px" }}>
      Diagnosi
    </Title>

    <Row gutter={[16, 24]} style={{ marginTop: "16px" }}>
      <Col xs={24}>
        <List
          bordered
          dataSource={diagnosi}
          renderItem={(item) => (
            <List.Item>
              <Text>{item}</Text>
            </List.Item>
          )}
        />
      </Col>
    </Row>

    {/* Sezione Trattamento */}
    {/* <Title level={2} style={{ marginTop: "36px" }}>
      Trattamento e Gestione
    </Title>

    <Row gutter={[16, 24]} style={{ marginTop: "16px" }}>
      <Col xs={24} md={14}>
        <List
          bordered
          dataSource={trattamento}
          renderItem={(item) => (
            <List.Item>
              <Text>{item}</Text>
            </List.Item>
          )}
        />
      </Col>

      <Col xs={24} md={10}>
        <Image
          src={immagineTrattamento}
          alt={altImmagineTrattamento}
          preview={false}
          style={{ width: "100%", height: "auto" }}
        />
      </Col>
    </Row> */}

    {/* Sezione Riferimenti */}
    {/* <Title level={2} style={{ marginTop: "36px" }}>
      Riferimenti e Risorse
    </Title>

    <Row gutter={[16, 24]} style={{ marginTop: "16px" }}>
      <Col xs={24}>
        <List
          bordered
          dataSource={riferimenti}
          renderItem={(item) => (
            <List.Item>
              <a href={item.link} target="_blank" rel="noopener noreferrer">
                {item.nome}
              </a>
            </List.Item>
          )}
        />
      </Col>
    </Row> */}
  </div>
);

export default MalattiaRaraTemplate;
